import React from 'react';
import { Helmet } from 'react-helmet';
import {
  FaUsers,
  FaComments,
  FaFileAlt,
  FaLaptopHouse,
  FaShieldAlt,
} from 'react-icons/fa';
import SEO from '../../components/SEO';


const OnlineCollaborationPlatforms = () => {
  return (
      <>
    <SEO title="Online Collaboration Platforms" />
    <div className="py-12 px-4 max-w-7xl mx-auto text-gray-800">
      <Helmet>
        <title>Online Collaboration Platforms | AKHSoft</title>
        <meta
          name="description"
          content="Empower remote teams with secure, scalable, and real-time online collaboration platforms tailored by AKHSoft for modern business needs."
        />
      </Helmet>

      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-[#0a3c6d] mb-4">
          Online Collaboration Platforms
        </h1>
        <p className="text-lg max-w-3xl mx-auto text-gray-600">
          Online Collaboration Platforms have revolutionized the way individuals and teams work together, especially in today’s increasingly remote and hybrid work environments. These platforms provide a virtual space where users can communicate, share files, manage projects, and collaborate on tasks in real-time, regardless of their physical location.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        {/* Feature 1 */}
        <div className="flex items-start space-x-5">
          <FaUsers className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Real-Time Communication
            </h3>
            <p className="text-gray-700">
              Online collaboration platforms offer real-time messaging, video conferencing, and voice calls. This allows team members to have instant discussions, hold virtual meetings, and make quick decisions without delays.
            </p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="flex items-start space-x-5">
          <FaComments className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Document Sharing and Editing
            </h3>
            <p className="text-gray-700">
              Users can upload, share, and collaboratively edit documents. Platforms like Google Workspace and Microsoft Teams allow multiple users to work on the same document simultaneously, with changes being visible in real time.
            </p>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="flex items-start space-x-5">
          <FaFileAlt className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Project Management Tools
            </h3>
            <p className="text-gray-700">
              Many collaboration platforms include project management features such as task assignment, deadlines, progress tracking, and calendar integration. These tools help teams stay organized and meet project goals.
            </p>
          </div>
        </div>

        {/* Feature 4 */}
        <div className="flex items-start space-x-5">
          <FaLaptopHouse className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              File Storage and Version Control
            </h3>
            <p className="text-gray-700">
              Files shared on collaboration platforms are often stored in the cloud, making them accessible from anywhere. Version control ensures that users can track changes and revert to previous versions if necessary.
            </p>
          </div>
        </div>

        {/* Feature 5 */}
        <div className="flex items-start space-x-5">
          <FaShieldAlt className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Integration with Other Tools
            </h3>
            <p className="text-gray-700">
              Most platforms integrate with other tools and services like email, CRM systems, and third-party apps. This creates a seamless workflow and reduces the need to switch between different applications.
            </p>
          </div>
        </div>

        {/* Additional Feature */}
        <div className="flex items-start space-x-5">
          <FaShieldAlt className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Access Control and Permissions
            </h3>
            <p className="text-gray-700">
              Administrators can set permissions to control who can view, edit, or delete content. This ensures that sensitive information is only accessible to authorized users.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-16 text-center">
        <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-4">
          Conclusion
        </h3>
        <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
          Online collaboration platforms are essential tools in the modern workplace. They enhance productivity, improve communication, and enable effective teamwork across distances. Whether for small teams or large enterprises, these platforms provide the infrastructure needed for successful collaboration in a digital world.
        </p>
        <a
          href="/contact"
          className="inline-block bg-[#0a3c6d] text-white py-3 px-6 rounded-lg hover:bg-blue-900 transition"
        >
          Let's Get Started
        </a>
      </div>
    </div>
    </>
  );
};

export default OnlineCollaborationPlatforms;
